import { agronomicZones, findNodeByLngLat } from '/@/core/zones';
import { getElevation } from './elevation';
import { reverseGeocode } from './geocoder';
import { getCenterOfGeometry } from './geometry';

const hasAgronomicZone = (node) => node && node.zones && node.zones.some((zone) => agronomicZones.includes(zone.type));

export const buildOnlineField = async ({ payload, zones, sessionCountry, sessionCountries }) => {
    const center = getCenterOfGeometry(payload.geometry);
    const field = {
        name: payload.name,
        area: payload.area,
        lng: center[0],
        lat: center[1],
        geometry: payload.geometry,
        mapValues: [],
    };

    const location = await reverseGeocode(center);
    if (!location.length) return { error: 'geocode' };

    field.altitude = await getElevation(center);
    if (!field.altitude) return { error: 'geocode' };

    const fieldCountry = sessionCountries.find(({ code }) => location.some((locat) => locat === code));
    if (!fieldCountry) return { error: 'zone' };

    const node = await findNodeByLngLat(field.lng, field.lat, zones, fieldCountry.code);
    if (!hasAgronomicZone(node)) return { error: 'zone' };

    field.country = fieldCountry.id;
    field.location = [...location.slice(0, location.length - 1), fieldCountry.name].join(', ');

    if (fieldCountry.code !== sessionCountry.code) return { field, error: 'country' };

    return { field, error: false };
};
